export default __webpack_public_path__ + "assets/3374657e380faf586ccbb01964b5d5e7.png";